import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
import {
    globalLoader,
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import { useTranslation } from "react-i18next";
import * as Yup from 'yup';
import * as productSubManagement from "../../../services/productSubManagement";
import * as productManagement from "../../../services/productManagement";
import { Loader, Tooltip, Whisper } from "rsuite";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const MAX_IMAGE_SIZE = 5 * 1024 * 1024;
const IMAGE_SIZE_ERROR = "Image size should not exceed 5 MB.";

const EditSubCategories = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [submitted, setSubmitted] = useState(false);
    const [submitClicked, setSubmitClicked] = useState(false);
    const [previewimage, setPreviewImage] = useState("");
    const [saveType, setSaveType] = useState("");
    const [dataLoaded, setDataLoaded] = useState(false);
    const [showdefault, setShowDefault] = useState({});
    const [categories, setCategories] = useState([]);

   const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: t("sub_categories"),
            url: "/admin/productManagement/subcategories/list/1",
        },
        { title: t("Edit"), url: "" },
    ];

    useEffect(() => {
        // Fetch categories for dropdown
        productManagement.List({ page: 1, per_page: 1000 }).then(res => {
            if (res.success) {
                setCategories(res.data.list);
            }
        });

        productSubManagement
            .Details(params.id)
            .then((response) => {
                setShowDefault(response && response.data ? response.data : []);
                setPreviewImage(response.data.image);
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.error("error=====>", error);
            });
    }, []);


    const validationSchema = Yup.object().shape({
        categoryId: Yup.string().required(t("validation_err_category_required")),
        // categoryIcon: Yup.array().of(
        //     Yup.object().shape({
        //         icon: Yup.string()
        //             .trim()
        //             .required('validation_err_icon_required')
        //             .max(50, 'validation_err_reached_maximum_length'),
        //     })
        // ),
        title: Yup.string()
            .trim()
            .required('label_title_error')
            .max(50, 'label_title_length_error_50'),
        description: Yup.string()
            .trim()
            .required('label_richtext_error')
            .max(150, t("label_desc_max_words_error", { count: 150 })),
        files: Yup.mixed()
            .test("fileType", t("label_image_format_error"), (value) => {
                if (!value || typeof value === "string") return true;
                const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
                return supportedFormats.includes(value.type);
            })
            .test("fileSize", IMAGE_SIZE_ERROR, (value) => {
                if (!value || typeof value === "string") return true;
                return value.size <= MAX_IMAGE_SIZE;
            }),
    });


    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {dataLoaded ? (
                <Formik
                    validateOnChange={true}
                    enableReinitialize
                    initialValues={{
                        categoryId: showdefault && showdefault.categoryId ? showdefault.categoryId : "",
                        title: showdefault && showdefault.title ? showdefault.title : "",
                        description: showdefault && showdefault.description ? showdefault.description : "",
                        files: showdefault && showdefault.image ? showdefault.image : "",
                        categoryIcon: showdefault?.icon
                            ? JSON.parse(showdefault.icon).map(i => ({ icon: i }))
                            : [{ icon: "" }]

                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        globalLoader(true);
                        setSubmitted(true);
                        const onlyIcons = values.categoryIcon.map(item => item.icon);
                        let formData = new FormData();
                        formData.append("_id", params.id);
                        formData.append("categoryId", values.categoryId);
                        formData.append("title", values.title);
                        formData.append("icon", JSON.stringify(onlyIcons));
                        formData.append("image", values.files);
                        formData.append("description", values.description);

                        productSubManagement
                            .Edit(formData)
                            .then((response) => {
                                setSubmitting(false);
                                if (response.success) {
                                    Swal.fire({
                                        icon: "success",
                                        text: response.message,
                                        ...SWAL_SETTINGS,
                                    });
                                    if (saveType !== "Save") {
                                        setTimeout(() => {
                                            globalLoader(false);
                                            navigate(`/admin/productManagement/subcategories/list/1`);
                                        }, 1000);
                                    } else {
                                        globalLoader(false);
                                    }
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        text: handleServerValidations(response),
                                        ...SWAL_SETTINGS,
                                    });
                                    setSubmitted(false);
                                    globalLoader(false);
                                }
                            })
                            .catch((error) => {
                                console.log("error ====> ", error);
                                setSubmitted(false);
                                globalLoader(false);
                            });
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="row row-sm">
                                <div className="col-lg-12 col-md-12 animation_fade">
                                    <div className="card custom-card">
                                        <div className="card-body">
                                            <div>
                                                <h6 className="main-content-label mb-3">{t("Edit Sub Category")}</h6>
                                            </div>
                                            <div className="row row-sm">
                                                <div className="col-md-12 text-center form-group">
                                                    <label htmlFor="categoryId" className="text-left d-flex">
                                                        {t("parent_category")}: <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    <select
                                                        name="categoryId"
                                                        id="categoryId"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.categoryId}
                                                        className="form-control"
                                                    >
                                                        <option value="">{t("select_category")}</option>
                                                        {categories.map((cat) => (
                                                            <option key={cat._id} value={cat._id}>{cat.title}</option>
                                                        ))}
                                                    </select>
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.categoryId && touched.categoryId && errors.categoryId}</span>
                                                </div>

                                                <div className="col-md-12 text-center form-group">
                                                    <label htmlFor="title" className="text-left d-flex">
                                                        {t("title")}: <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    <input
                                                        name="title"
                                                        id="title"
                                                        type="text"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.title}
                                                        className="form-control"
                                                        placeholder="Enter title"
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.title && touched.title && t(errors.title)}</span>
                                                </div>
                                                <div className="col-md-12 text-center form-group">
                                                    <label htmlFor="description" className="text-left d-flex">
                                                        {t("label_description")}: <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    <input
                                                        name="description"
                                                        id="description"
                                                        type="text"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.description}
                                                        className="form-control"
                                                        placeholder="Enter description"
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.description && touched.description && t(errors.description)}</span>
                                                </div>
                                                <div className="col-lg-12 text-center form-group">
                                                    <label htmlFor="files" className="text-left d-flex">
                                                        {t("label_image")}:<span className="requirestar">*</span>
                                                        <Whisper
                                                            placement="top"
                                                            controlId="control-id-hover"
                                                            trigger="hover"
                                                            speaker={
                                                                <Tooltip>Recommended Size (1920x887)</Tooltip>
                                                            }
                                                        >
                                                            <span className="field-more-info mt-1 ms-1 cp">
                                                                ?
                                                            </span>
                                                        </Whisper>
                                                    </label>
                                                    <input
                                                        className="form-control imgInput"
                                                        id="files"
                                                        name="files"
                                                        accept="image/*"
                                                        type="file"
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                "files",
                                                                event.currentTarget.files[0] || ""
                                                            );
                                                            event.currentTarget.files.length === 1
                                                                ? setPreviewImage(
                                                                    URL.createObjectURL(
                                                                        event.currentTarget.files[0]
                                                                    )
                                                                )
                                                                : setPreviewImage("");
                                                        }}
                                                    />
                                                    <span
                                                        className="text-danger d-flex text-left"
                                                        id="errortext"
                                                    >
                                                        {errors.files && touched.files && errors.files}
                                                    </span>
                                                </div>

                                                {previewimage ? (
                                                    <ul className="question-image-preview questions-ul">
                                                        <li className="pr_img_box">
                                                            <img
                                                                src={previewimage}
                                                                style={{ height: "100px" }}
                                                                alt={t("banner-image")}
                                                            />
                                                            <div className="img_options">
                                                                <button type="button" className="text-danger"
                                                                    onClick={() => {
                                                                        setPreviewImage("");
                                                                        setFieldValue("files", "");
                                                                        document.getElementById("files").value = ""
                                                                    }}>
                                                                    <i className="ri-delete-bin-6-fill"></i>
                                                                </button>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                ) : (
                                                    ""
                                                )}

                                            

                                                <div className="mt-5">
                                                    <button
                                                        onClick={() => setSaveType("Save")}
                                                        className="btn btn-info mr-2"
                                                        type="submit"
                                                    >
                                                        <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                        {t("btn_save")}
                                                    </button>

                                                    <button
                                                        onClick={() => setSaveType("Exit")}
                                                        className="btn btn-success mr-2"
                                                        type="submit"
                                                    >
                                                        <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                        {t("btn_save_exit")}
                                                    </button>

                                                    <button
                                                        className="btn ripple btn-secondary"
                                                        type="button"
                                                        onClick={() => navigate("/admin/productManagement/subcategories/list/1")}
                                                    >
                                                        <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                        {t("btn_cancel")}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            ) : (
                <Loader />
            )}
        </>
    );
};

export default EditSubCategories;
